import axios from 'axios';
import { getDefaultStore } from 'jotai';
import { ANALYTICS_ENVIRONMENT, ENABLE_LOGGING } from '../config/env';
import { clientAtom, hostAtom } from '../GlobalState';

const SESSION_ID_KEY = 'yutAnalyticsSessionId';
const analyticsEndpoint = 'https://yqpd9l2hjh.execute-api.us-west-2.amazonaws.com/dev/sendLog';
const store = getDefaultStore();

function getSessionId() {
  let sessionId = window.sessionStorage.getItem(SESSION_ID_KEY);

  if (!sessionId) {
    sessionId = window.crypto.randomUUID();
    window.sessionStorage.setItem(SESSION_ID_KEY, sessionId);
  }

  return sessionId;
}

function getPlayerType(surface) {
  if (surface === 'home') return null;

  const client = store.get(clientAtom);
  const host = store.get(hostAtom);

  if (!client?.socketId || !Number.isInteger(client.team)) return null;
  if (client.socketId === host?.socketId) return 'host';

  return client.team === -1 ? 'spectator' : 'player';
}

export async function trackEvent({ surface, action, category, metadata = {}, roomId = null }) {
  if (!ENABLE_LOGGING) {
    console.log('[DEV] Analytics event skipped:', { surface, action, category, metadata, roomId });
    return null;
  }

  try {
    const response = await axios.post(analyticsEndpoint, {
      occurredAt: new Date().toISOString(),
      environment: ANALYTICS_ENVIRONMENT,
      page: window.location.pathname,
      surface,
      action,
      category,
      sessionId: getSessionId(),
      playerType: getPlayerType(surface),
      roomId,
      metadata
    });
    return response;
  } catch (error) {
    console.error('Error sending analytics event:', error);
    return null;
  }
}
